import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserService } from '@markant-platform/shared/user/data-access';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'markant-platform-mfa-select-page',
  templateUrl: 'mfa-select.page.component.html',
  styleUrls: ['./mfa-select-page.component.scss'],
})
export class MfaSelectPageComponent implements OnInit {
  @Input() mfaSelectForm = new FormGroup({
    selectedMfaMethod: new FormControl<'APP' | 'EMAIL' | undefined>(undefined, [Validators.required]),
  });

  selectedMfaMethod?: 'APP' | 'EMAIL';
  sessionToken?: string;
  redirectUri?: string;
  state?: string;

  constructor(
    private readonly userService: UserService,
    private readonly destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    this.sessionToken = urlParams.get('session_token') as string;
    this.redirectUri = urlParams.get('redirect_uri') as string;
    this.state = urlParams.get('state') as string;
  }

  select(selected: 'APP' | 'EMAIL'): void {
    this.selectedMfaMethod = selected;
  }

  continueMfaSelection(): void {
    this.userService
      .mfaSelect(this.selectedMfaMethod, this.sessionToken, this.redirectUri, this.state)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(dto => {
        window.location.href = dto.redirectUri;
      });
  }
}
